import script from "./PandoraFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./PandoraFooter.vue?vue&type=script&setup=true&lang=js"

import "./PandoraFooter.vue?vue&type=style&index=0&id=6c903762&lang=css"

const __exports__ = script;

export default __exports__